import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { UserOutlined } from "@ant-design/icons";
import { Layout, Typography } from "antd";
import { SalesTerms } from "@gull/ui";
import { useAuth } from "./lib/auth";
import DevLoginButton from "./components/DevLoginButton";
import BestillPose from "./pages/bestill-pose/BestillPose";
import Book from "./pages/Book";
import CustomerTransactionDetail from "./pages/CustomerTransactionDetail";
import DeliveryStatus from "./pages/status/DeliveryStatus";
import Landing from "./pages/Landing";
import MinSide from "./pages/min-side/MinSide";
import VerifyEmail from "./pages/VerifyEmail";

const DEV_LOGIN = import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === "true";

const { Header, Content } = Layout;
const { Title, Paragraph } = Typography;

function Stub({ title }: { title: string }) {
  return (
    <Content style={{ maxWidth: 760, margin: "0 auto", padding: "48px 24px" }}>
      <Title level={2}>{title}</Title>
      <Paragraph type="secondary">Stub. Implementeres senere.</Paragraph>
      <Link to="/">Tilbake</Link>
    </Content>
  );
}

function SiteHeader() {
  const { user, signInWithVipps } = useAuth();
  const location = useLocation();
  const isStatusPage =
    location.pathname.startsWith("/status/") ||
    location.pathname.startsWith("/godkjenn-innlevering/");

  return (
    <Header
      style={{
        background: "#ffffff",
        padding: "18px 32px 22px",
        borderBottom: "1px solid rgba(13, 12, 12, 0.08)",
        position: "sticky",
        top: 0,
        zIndex: 10,
        height: "auto",
        lineHeight: "normal",
      }}
    >
      <div
        style={{
          maxWidth: 1340,
          margin: "0 auto",
          minHeight: 48,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        {isStatusPage ? (
          <div
            className="site-header-wordmark"
            style={{
              display: "flex",
              alignItems: "center",
              color: "#090d25",
            }}
          >
            <img className="da-wordmark" src="/da-wordmark.svg" alt="David-Andersen" />
          </div>
        ) : (
          <Link
            to="/"
            className="site-header-wordmark"
            style={{
              display: "flex",
              alignItems: "center",
              color: "#090d25",
              textDecoration: "none",
            }}
          >
            <img className="da-wordmark" src="/da-wordmark.svg" alt="David-Andersen" />
          </Link>
        )}

        {isStatusPage ? null : (
          <nav className="site-header-nav" aria-label="Hovedmeny">
            {user ? (
              <Link className="site-header-icon" to="/min-side" aria-label="Min side">
                <UserOutlined />
              </Link>
            ) : (
              <button
                className="site-header-icon"
                type="button"
                onClick={signInWithVipps}
                aria-label="Logg inn"
              >
                <UserOutlined />
              </button>
            )}
          </nav>
        )}
      </div>
    </Header>
  );
}

export default function App() {
  return (
    <Layout style={{ minHeight: "100%", background: "#ffffff" }}>
      <SiteHeader />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/book" element={<Book />} />
        <Route path="/logg-inn" element={<Navigate to="/" replace />} />
        <Route path="/status/:referenceNumber" element={<DeliveryStatus />} />
        <Route path="/godkjenn-innlevering/:approvalToken" element={<DeliveryStatus />} />
        <Route path="/min-side/transaksjoner/:id" element={<CustomerTransactionDetail />} />
        <Route path="/min-side/*" element={<MinSide />} />
        <Route path="/bestill-pose" element={<BestillPose />} />
        <Route path="/vilkar" element={<SalesTerms />} />
        <Route path="/verifiser-epost" element={<VerifyEmail />} />
        <Route path="*" element={<Stub title="Side ikke funnet" />} />
      </Routes>
      {DEV_LOGIN ? <DevLoginButton /> : null}
    </Layout>
  );
}
